<template>
  <div>
    <a-row>
      <g-master name="project"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                modalWidth="80%"
                :actions="master.actions"
      >
        <span slot="estadoRenderer" slot-scope="{text}">
          <a-tag :color="text==='PENDIENTE' ? 'red' : (text === 'COMPLETO' ? 'green' : 'blue')">{{text}}</a-tag>
        </span>
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('ID Tarea')">
                <a-input style="width: 100%;" readOnly :disabled="true"
                         v-decorator="['id_task_detail', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('ID Persona Proyecto')">
                <a-input style="width: 100%;" readOnly :disabled="true"
                         v-decorator="['id_project_persona', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio')">
                <a-date-picker style="width: 100%"
                               v-decorator="['ini_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                ></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Fecha fin')">
                <a-date-picker style="width: 100%"
                               v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                ></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Estado')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_status_task_person', { rules: [{ required: false }] }]"
                          :params="estado_proyecto">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Comentarios')">
                <a-textarea autoSize
                  v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        estado_proyecto: {
          h_lookup_type: 'GP_ESTADO_PROYECTOYTAREAS'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'project_task_person',
          actions: [],
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado el', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado el', column: 'modified_on'}
          ],
          tableSetup: {
            customSlots: ['estadoRenderer', 'expandedRowRender'],
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return record.persona === this.$store.state.userInfo.name
                  }
                }
              ]
            },
            columns: [
              {title: 'Tarea', dataIndex: 'tarea', sorter: true},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true, width: 400},
              {title: 'Fecha Inicio', dataIndex: 'f_ini', sorter: true},
              {title: 'Fecha Fin', dataIndex: 'f_fin', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                width: 110,
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Asignada A', dataIndex: 'persona', sorter: true},
              {title: 'Asignada Por', dataIndex: 'created_by', sorter: true}
            ]
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GestionDeProyectos/ProjectTaskPerson.vue